document.addEventListener('DOMContentLoaded', function() {
  const applicationForm = document.getElementById('applicationForm');
  const modal = document.querySelector('.application-form__modal');
  const modalContent = document.querySelector('.application-form__modal-content');
  const modalClose = document.querySelector('.application-form__modal-close');
  const continueButton = document.querySelector('.application-form__modal-continue');
  const cancelButton = document.querySelector('.application-form__modal-cancel');
  const submitButton = document.getElementById('submitButton');
  const loadingSpinner = document.querySelector('.application-form__loading-spinner');
  const tosCheckbox = document.getElementById('tos');
  const tosTrigger = document.querySelector('.tos-trigger');
  
  let formHasBeenSubmitted = false;
  
  const hasFormSuccess = document.querySelector('.form-status');
  const hasFormErrors = document.querySelector('.form__message:not(.form-status)');
  
  const fullScreenLoader = createFullScreenLoader();
  document.body.appendChild(fullScreenLoader);
  
  let errorMessageContainer = document.querySelector('.application-form__error-message');
  if (!errorMessageContainer) {
    errorMessageContainer = createErrorMessageContainer();
    if (submitButton) {
      submitButton.parentNode.insertBefore(errorMessageContainer, submitButton);
    }
  }
  
  if (hasFormErrors) {
    const errorList = document.querySelectorAll('.form-status-list li');
    if (errorList.length > 0) {
      const errorMessages = Array.from(errorList).map(el => el.textContent.trim()).join('<br>');
      showErrorMessage(errorMessages);
    }
    formHasBeenSubmitted = false;
  }
  
  if (hasFormSuccess) {
    window.location.href = '/pages/application-successful';
    return;
  }
  
  // Handle TOS checkbox click to show modal
  if (tosCheckbox && tosTrigger) {
    tosCheckbox.addEventListener('change', function(event) {
      if (this.checked) {
        event.preventDefault();
        this.checked = false; // Uncheck it until they accept via modal
        showModal();
      }
    });
    
    // Also handle clicking on the label text
    tosTrigger.addEventListener('click', function(event) {
      if (event.target.classList.contains('tos-link') || event.target.closest('.tos-link')) {
        event.preventDefault();
        showModal();
      }
    });
  }
  
  // Handle form submission
  if (applicationForm) {
    applicationForm.addEventListener('submit', function(event) {
      // Check if form is valid before submitting
        if (!applicationForm.checkValidity()) {
          // Form is invalid, let browser show validation messages
          return;
        }
        
      // Check if TOS is accepted
      if (!tosCheckbox.checked) {
        event.preventDefault();
        showErrorMessage('Please accept the Minimum Advertised Pricing (MAP) Agreement to continue.');
        return;
      }
      
      if (!formHasBeenSubmitted) {
        event.preventDefault();
        formHasBeenSubmitted = true;
        showFullScreenLoader();
        // Submit the form after a short delay to show the loader
        setTimeout(() => {
          applicationForm.submit();
        }, 500);
        }
      });
  }
  
  function createFullScreenLoader() {
    const loader = document.createElement('div');
    loader.className = 'application-form__fullscreen-loader';
    loader.innerHTML = `
      <div class="application-form__fullscreen-loader-content">
        <div class="application-form__fullscreen-loader-spinner"></div>
        <p class="application-form__fullscreen-loader-text">Submitting your application...</p>
      </div>
    `;
    return loader;
  }
  
  function createErrorMessageContainer() {
    const errorContainer = document.createElement('div');
    errorContainer.className = 'application-form__error-message';
    return errorContainer;
  }
  
  function showFullScreenLoader() {
    fullScreenLoader.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  
  function showErrorMessage(message) {
    errorMessageContainer.innerHTML = `
      <h4>There was an error submitting your application</h4>
      <p>${message}</p>
    `;
    errorMessageContainer.classList.add('show');
    errorMessageContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  
  function hideErrorMessage() {
    errorMessageContainer.classList.remove('show');
  }
  
  function showModal() {
    if (modal) {
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
      
      if (modalContent) {
        modalContent.scrollTop = 0;
      }
      
      if (continueButton) {
        continueButton.setAttribute('disabled', '');
      }
      
      if (loadingSpinner) {
        loadingSpinner.classList.add('hidden');
      }
    }
  }
  
  function hideModal(acceptedTerms = false) {
    if (modal) {
      modal.classList.remove('active');
      document.body.style.overflow = '';
      
      // Reset modal state
      if (continueButton) {
        continueButton.style.display = '';
        continueButton.setAttribute('disabled', '');
    }
      if (cancelButton) {
        cancelButton.style.display = '';
      }
    if (loadingSpinner) {
        loadingSpinner.classList.add('hidden');
    }
      
      // If terms were accepted via continue button, check the checkbox
      if (acceptedTerms && tosCheckbox) {
        tosCheckbox.checked = true;
      }
    }
  }
  
  function acceptTermsAndCloseModal() {
    hideErrorMessage();
    hideModal(true); // Pass true to indicate terms were accepted
  }
  
  if (modal) {
    if (modalClose) {
      modalClose.addEventListener('click', function() {
        hideModal(false); // Don't accept terms when closing via X
      });
    }
    
    modal.addEventListener('click', function(event) {
      if (event.target === modal) {
        hideModal(false); // Don't accept terms when closing via backdrop
      }
    });
    
    if (continueButton) {
      continueButton.addEventListener('click', function() {
        if (!continueButton.disabled) {
          acceptTermsAndCloseModal();
        }
      });
    }
    
    if (cancelButton) {
      cancelButton.addEventListener('click', function() {
        hideModal(false); // Don't accept terms when canceling
      });
    }
    
    if (modalContent && continueButton) {
      modalContent.addEventListener('scroll', function() {
        const isAtBottom = modalContent.scrollHeight - modalContent.scrollTop <= modalContent.clientHeight + 10;
        if (isAtBottom) {
          continueButton.removeAttribute('disabled');
        } else {
          continueButton.setAttribute('disabled', '');
        }
      });
    }
  }
}); 